import request from '@/utils/request';

/**
 * 登录api接口集合
 * @method signIn 用户登录
 * @method signOut 用户退出登录
 */
export function useLoginApi () {
  return {
    // 登录
    signIn: params => {
      return request ({
        url: '/admin/login',
        method: 'post',
        data: params,
      });
    },
    //退出
    signOut: params => {
      return request ({
        url: '/admin/login',
        method: 'post',
        data: params,
      });
    },
    // 路由
    getMenuAdmin: params => {
      return request ({
        url: '/admin/auth/admin/navigation_bar',
        method: 'get',
        params,
      });
    },

    //用户信息
    getUserinfo: params => {
      return request ({
        url: '/admin/auth/info',
        method: 'get',
        params,
      });
    },

    //验证码二次验证
    getCaptchaAppId: params => {
      return request ({
        url: '/admin/captcha_app_id',
        method: 'get',
        params,
      });
    },

    //验证码二次验证
    getCaptcha: params => {
      return request ({
        url: '/admin/captcha',
        method: 'post',
        params,
      });
    },

    // 伪登录
    getToken: params => {
      return request ({
        url: '/admin/get_token_by_id',
        method: 'post',
        data: params,
      });
    },
  };
}
